// tslint:disable
export enum Dpv {
    /**
     * @description DPV unknown or not provided
     */
    Unknown = 0,
    /**
     * @description Address is a valid mailing address
     */
    Valid = 1,
    /**
     * @description Address is not in the DPV database of valid mailing addresses
     */
    Invalid = 2,
    /**
     * @description Apartment or Rural Route Box invalid
     */
    AptOrRrBoxInvalid = 3,
    /**
     * @description Apartment or Rural Route Box missing
     */
    AptOrRrBoxMissing = 4,
}
(Dpv as any)['UNKNOWN'] = 0;
(Dpv as any)['VALID'] = 1;
(Dpv as any)['INVALID'] = 2;
(Dpv as any)['APTORRRBOXINVALID'] = 3;
(Dpv as any)['APTORRRBOXMISSING'] = 4;
